import React, { useState } from "react";
import EmployeeTransactionAccessTable from "./components/EmployeeTransactionAccessTable";
import EmployeeTransactionAccessAddEditModal from "./components/EmployeeTransactionAccessAddEditModal";
import { SearchBar } from "../../../../common/APICommon";

const EmployeeTransactionAccessModule = ({
  user,
  data,
  searchData,
  updateAccess
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const handleSearch = (value) => {
    setCurrentPage(1);
    searchData(value);
  };

  const handleSave = async (form) => {
    if (!selectedItem) return;

    // Prepare Audit Trail by comparing changes
    const auditEntries = [];
    const fieldsToTrack = [
      { key: "allowSkipApproval", label: "Allow Skip Approval" },
      { key: "isEmployeeTransactionAssignmentManager", label: "Assignment Manager" },
      { key: "isEmployeeTransactionCompensationManager", label: "Compensation Manager" },
      { key: "isEmployeeTransactionScheduleManager", label: "Schedule Manager" },
      { key: "isEmployeeTransactionAssignedEmployee", label: "Assigned Employee" }
    ];

    fieldsToTrack.forEach(field => {
      const oldValue = !!selectedItem[field.key] ? "Yes" : "No";
      const newValue = !!form[field.key] ? "Yes" : "No";

      if (oldValue !== newValue) {
        auditEntries.push({
          setupArea: "Employee Transaction Access",
          actionTaken: "update",
          field: `${selectedItem.description} - ${field.label}`,
          oldValue: oldValue,
          newValue: newValue,
          dateSaved: new Date(),
          savedById: user.id
        });
      }
    });

    const res = await updateAccess(selectedItem.id, form, auditEntries);
    if (res.success) setIsModalOpen(false);
  };

  return (
    <div className='p-4 space-y-4 relative'>
      <div className="flex justify-between items-center">
        <SearchBar handleFilter={handleSearch} />
      </div>

      <EmployeeTransactionAccessTable
        data={data}
        onEdit={handleEdit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />

      <EmployeeTransactionAccessAddEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedItem={selectedItem}
        onSave={handleSave}
      />
    </div>
  );
};

export default EmployeeTransactionAccessModule;